import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'
import { EndOfJourneyReviewsSummaryRequest, EndOfJourneyReviewsSummaryResponse } from './types'

export function getEndOfJourneyReviewsSummary(input: EndOfJourneyReviewsSummaryRequest) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API['end-of-journey-reviews-summary'].get.url, null),
        input
      )
    )
    .get<EndOfJourneyReviewsSummaryResponse>()
}
